import {
  isGbpDisplayCurrency,
  resolveStorefrontMarket,
  type ResolveStorefrontMarketArgs,
} from '@/lib/storefront/resolveStorefrontMarket'

export type ResolveDisplayCurrencyArgs = Pick<
  ResolveStorefrontMarketArgs,
  | 'host'
  | 'hostBrand'
  | 'fallbackBrand'
  | 'currencyCode'
  | 'currencySymbol'
  | 'cartCurrencyCode'
  | 'cartCurrencySymbol'
>

export const resolveDisplayCurrency = (args: ResolveDisplayCurrencyArgs) => {
  const market = resolveStorefrontMarket(args)

  return {
    currencyCode: market.currencyCode,
    currencySymbol: market.currencySymbol,
    storefrontBrand: market.brandCode,
  }
}
export { isGbpDisplayCurrency }
